import { useState } from 'react';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { useAuth, ROLE_SI_ADMIN } from '@/contexts/AuthContext';
import ConfiguracoesDrawer from '@/features/SI/pages/SolicitacoesListPage/components/ConfiguracoesDrawer';
import { SI_PORTAL_SUBTITLE, SI_PORTAL_TITLE } from '../siPortal.definitions';
import { SiPortalTabNav } from './SiPortalTabNav';
import { SiPortalAjuda } from '../tour/SiPortalAjuda';

/** Cabeçalho no padrão do Portal do DP. A engrenagem (Configurações do SI) saiu do
 * cabeçalho da antiga lista e fica aqui, visível em qualquer aba — só pro SI. */
export function SiPortalHeader() {
  const { userHasRole } = useAuth();
  const isSI = userHasRole(ROLE_SI_ADMIN);
  const [configAberta, setConfigAberta] = useState(false);

  return (
    <header className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
      <div className="min-w-0">
        <h1 className="font-montserrat text-3xl font-bold text-raro-gray-900 sm:text-4xl">{SI_PORTAL_TITLE}</h1>
        <p className="mt-1 font-montserrat text-sm text-raro-gray-500">{SI_PORTAL_SUBTITLE}</p>
      </div>
      <div className="flex min-w-0 items-center gap-2">
        <SiPortalTabNav />
        <SiPortalAjuda />
        {isSI && (
          <>
            <button
              type="button"
              onClick={() => setConfigAberta(true)}
              className="shrink-0 rounded-full p-2 text-raro-gray-500 transition-colors hover:bg-white hover:text-primary-700"
              title="Configurações do SI"
              aria-label="Configurações do SI"
            >
              <Cog6ToothIcon className="h-5 w-5" />
            </button>
            <ConfiguracoesDrawer isOpen={configAberta} onClose={() => setConfigAberta(false)} />
          </>
        )}
      </div>
    </header>
  );
}
